module.exports = __webpack_public_path__ + "img/ueber-mich-1_960.19652dc8.jpg";